import { render, staticRenderFns } from "./Ledger.vue?vue&type=template&id=4f83d082&scoped=true"
import script from "./Ledger.vue?vue&type=script&lang=js"
export * from "./Ledger.vue?vue&type=script&lang=js"
import style0 from "./Ledger.vue?vue&type=style&index=0&id=4f83d082&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f83d082",
  null
  
)

export default component.exports